import cookie from "@/core/cookie"
import settings from "@/core/settings"

export default function klaviyoCookie() {
  if (settings && settings.klaviyoCookie) {
    return cookie.get("__kla_id") || undefined
  }
  return undefined
}
